/* eslint-disable react/prop-types */
import React, { useState } from "react";
import img_crosschain from "./../img/crosschain.webp";
import img_trade from "./../img/trade.webp";
import img_moon1 from "./../img/moonbeam-1.webp";
import img_moon2 from "./../img/moonbeam-2.webp";

const FoundationClosing = () => {
  const [copied, setCopied] = useState(false);

  const codeSnippet = `const headData = await api.query.paras.heads(3370);
const header = api.createType('Header', headData.unwrap());
console.log('LAOS block number:', header.number.toNumber());
console.log('LAOS parent hash:', header.parentHash.toHex());
console.log('LAOS state root:', header.stateRoot.toHex());`;

  const handleCopy = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      <div className="container mx-auto px-6 md:px-10 mt-12 max-w-5xl">

        {/* Announcement */}
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-8">
          LAOS Network is becoming 100% decentralized
        </h1>

        <div className="mb-6 leading-relaxed space-y-4">

          <p>
            LAOS Network is fully decentralized. The LAOS Foundation, the
            not-for-profit organization that helped create LAOS, is closing.
            From 2026 onward, it will no longer support LAOS, and the community
            portals it maintains (website, X account, Discord, Telegram)
            will be shuttered.
          </p>

          {/* URGENT CALL TO THE COMMUNITY */}
          <div className="border-2 border-red-500 bg-red-950/40 rounded-lg overflow-hidden shadow-lg shadow-red-900/30">

            {/* Header badge */}
            <div className="bg-red-600 px-5 py-3 flex items-center gap-3">
              <span className="text-2xl">🚨</span>
              <span className="text-white font-extrabold text-lg uppercase tracking-widest">
                Urgent Call to the Community
              </span>
              <span className="text-2xl">🚨</span>
            </div>

            <div className="px-5 py-4 space-y-4">

              {/* Positive fact */}
              <p className="font-semibold text-green-400 flex items-start gap-2">
                <span>✅</span>
                <span>A new community-maintained LAOS Public Node is needed in order for the LAOS blockchain to remain operational.</span>
              </p>

              {/* Urgent issue 1 */}
              <div className="border-l-4 border-orange-400 pl-4">
                <p className="font-bold text-orange-400 uppercase text-sm tracking-wide mb-1">
                  🔴 Critical
                </p>
                <p>
                  The <strong className="text-white">LAOS Public Node</strong> — used by{" "}
                  <a className="text-fvyellow hover:underline font-semibold" href="https://laos.statescan.io/" target="_blank" rel="noopener noreferrer">
                    Polkadot.js
                  </a>
                  , user wallets and by{" "}
                  <a className="text-fvyellow hover:underline font-semibold" href="https://laos.statescan.io/" target="_blank" rel="noopener noreferrer">
                    Statescan
                  </a>
                  {" "}to provide a public blockchain explorer — <strong className="text-orange-400">will be shut down</strong> on May 11th, 2026.
                  If the community does not run and maintain a replacement public node, it will be almost impossible to use the LAOS blockchain.
                  Should you have any questions, please <a className="text-fvyellow hover:underline font-semibold" href="https://github.com/freeverseio/laos/issues" target="_blank" rel="noopener noreferrer">open an issue</a>
                  {" "} in the LAOS GitHub repository.
                </p>
                <p className="text-orange-200">
                  The blockchain will still produce blocks as long as collators remain. Block inclusion in the Polkadot
                  relay chain can be checked in <a className="text-fvyellow hover:underline font-semibold" href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fpolkadot-rpc.publicnode.com#/js" target="_blank" rel="noopener noreferrer">Polkadot.js</a>,
                  by querying:
                </p>
                <div style={{
                  position: 'relative',
                  background: '#0d1117',
                  border: '1px solid #30363d',
                  borderRadius: '8px',
                  marginTop: '10px',
                  fontFamily: '"Fira Code", "Cascadia Code", "Consolas", monospace',
                  fontSize: '0.78rem',
                  lineHeight: '1.7',
                  overflow: 'hidden',
                }}>
                  {/* Header bar */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 14px',
                    background: '#161b22',
                    borderBottom: '1px solid #30363d',
                  }}>
                    <span style={{ color: '#8b949e', fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>JavaScript</span>
                    <button
                      onClick={handleCopy}
                      title={copied ? 'Copied!' : 'Copy to clipboard'}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        background: 'none',
                        border: '1px solid',
                        borderColor: copied ? '#3fb950' : '#30363d',
                        borderRadius: '5px',
                        padding: '3px 10px',
                        cursor: 'pointer',
                        color: copied ? '#3fb950' : '#8b949e',
                        fontSize: '0.7rem',
                        transition: 'all 0.2s',
                      }}
                    >
                      {copied ? (
                        <>
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.75.75 0 0 1 1.06-1.06L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0z" /></svg>
                          Copied!
                        </>
                      ) : (
                        <>
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z" /><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z" /></svg>
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                  {/* Code lines */}
                  <pre style={{ margin: 0, padding: '14px 18px', overflowX: 'auto' }}><code>
                    <div><span style={{ color: '#ff7b72' }}>const</span><span style={{ color: '#e6edf3' }}> headData </span><span style={{ color: '#ff7b72' }}>=</span><span style={{ color: '#79c0ff' }}> await</span><span style={{ color: '#e6edf3' }}> api.query.paras.</span><span style={{ color: '#d2a8ff' }}>heads</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#79c0ff' }}>3370</span><span style={{ color: '#e6edf3' }}>);</span></div>
                    <div><span style={{ color: '#ff7b72' }}>const</span><span style={{ color: '#e6edf3' }}> header </span><span style={{ color: '#ff7b72' }}>=</span><span style={{ color: '#e6edf3' }}> api.</span><span style={{ color: '#d2a8ff' }}>createType</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;Header&apos;</span><span style={{ color: '#e6edf3' }}>, headData.</span><span style={{ color: '#d2a8ff' }}>unwrap</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS block number:&apos;</span><span style={{ color: '#e6edf3' }}>, header.number.</span><span style={{ color: '#d2a8ff' }}>toNumber</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS parent hash:&apos;</span><span style={{ color: '#e6edf3' }}>, header.parentHash.</span><span style={{ color: '#d2a8ff' }}>toHex</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS state root:&apos;</span><span style={{ color: '#e6edf3' }}>, header.stateRoot.</span><span style={{ color: '#d2a8ff' }}>toHex</span><span style={{ color: '#e6edf3' }}>());</span></div>
                  </code></pre>
                </div>
              </div>

              {/* Call to action footer */}
              <p className="text-center font-bold text-white bg-red-700/50 rounded-md py-2 mt-2 tracking-wide">
                🔔 Act now — the future of LAOS is in the community&apos;s hands.
              </p>

            </div>
          </div>

        </div>



        <div className="mb-8">
          <p className="font-semibold mb-3 text-lg">LAOS token can only be traded in Decentralized Exchanges:</p>

          <ul className="space-y-3 list-disc list-inside">
            {/* Hydration */}
            <li>
              <a
                className="text-fvyellow hover:underline font-medium"
                href="https://app.hydration.net/trade/swap?assetIn=5&assetOut=3370"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hydration
              </a>
            </li>

            {/* StellaSwap */}
            <li>
              <a
                className="text-fvyellow hover:underline font-medium"
                href="https://app.stellaswap.com/exchange/swap"
                target="_blank"
                rel="noopener noreferrer"
              >
                StellaSwap
              </a>
            </li>
          </ul>
        </div>

        <div className="mb-10">
          <h3 className="font-semibold text-lg mb-4">
            Trading Resources
          </h3>

          <ul className="list-disc list-inside space-y-3">
            <li>
              For those who had LAOS on Bit2Me (not operational as of April 2026), this tutorial shows how to move those LAOS to DEXs:{" "}
              <a
                className="text-fvyellow hover:underline inline-flex items-center gap-1 font-semibold"
                href="https://www.youtube.com/watch?v=cJ4gUNDP3Zo"
                target="_blank"
                rel="noopener noreferrer"
              >
                ▶ Watch on YouTube
              </a>
            </li>

            <li>
              A guide to trading on Hydration and StellaSwap is provided below.
            </li>
          </ul>
        </div>

        <div className="mb-16 text-center">
          <p className="text-lg md:text-xl font-medium">
            💛 The LAOS Foundation sincerely thanks our community and the builders
            who helped shape and grow the ecosystem.
            Your contributions and commitment made this journey possible. 💛
          </p>
        </div>

      </div>

      {/* Guide Section */}
      <section
        className="py-14 border-t-2 border-b-2 border-fvyellow"
        style={{
          background: "linear-gradient(144deg, #25143b 21%, #613d93 79%)",
        }}
      >
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-white">

          <h2 className="text-2xl font-bold text-center mb-10">
            Guide for Trading on Hydration and StellaSwap
          </h2>

          <p className="mb-6 leading-relaxed">
            LAOS remains tradable on decentralized exchanges such as Hydration
            and StellaSwap, allowing non-custodial access across the Polkadot
            ecosystem.
          </p>

          {/* Hydration */}
          <h3 className="text-xl font-semibold mb-4 text-fvyellow">
            LAOS on Hydration
          </h3>

          <ol className="list-decimal list-inside space-y-4 mb-8">
            <li>
              Fund your Hydration account with a small amount of HDX to cover
              transaction fees.
            </li>
            <li>
              Use Hydration’s cross-chain app to transfer LAOS from your LAOS
              account to Hydration.
            </li>
            <li>
              Inside Hydration, use Trade → Swap to exchange LAOS for DOT,
              USDT, or other supported assets.
            </li>
          </ol>

          <img src={img_crosschain} alt="Cross chain transfer" className="mb-8 rounded shadow-lg" />
          <img src={img_trade} alt="Hydration trading" className="mb-12 rounded shadow-lg" />

          {/* StellaSwap */}
          <h3 className="text-xl font-semibold mb-4 text-fvyellow">
            LAOS on StellaSwap (Moonbeam)
          </h3>

          <ol className="list-decimal list-inside space-y-4 mb-8">
            <li>
              Fund your Moonbeam account with a small amount of GLMR for fees.
            </li>
            <li>
              Use Moonbeam’s XCM interface to transfer LAOS to Moonbeam.
            </li>
            <li>
              On StellaSwap, use Swap → Trade to exchange LAOS into DOT, GLMR,
              USDT, ETH, or other supported assets.
            </li>
          </ol>

          <img src={img_moon1} alt="Moonbeam transfer" className="mb-8 rounded shadow-lg" />
          <img src={img_moon2} alt="StellaSwap trading" className="rounded shadow-lg" />

        </div>
      </section>
    </>
  );
};

export default FoundationClosing;
